import '@modifi/client-polyfills'
import React, {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'

import getApp from './App'

const config = {
  useSuspense: true,
  plugins: {
    i18n: {
      react: {
        useSuspense: true,
      },
    },
  },
}

getApp(config).then(App =>
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
)
